import { render, staticRenderFns } from "./showfirst.vue?vue&type=template&id=3b8c92cc&scoped=true&"
import script from "./showfirst.vue?vue&type=script&lang=js&"
export * from "./showfirst.vue?vue&type=script&lang=js&"
import style0 from "./showfirst.vue?vue&type=style&index=0&id=3b8c92cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c92cc",
  null
  
)

export default component.exports